<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch4">
<div class="chapterHead">
<p class="centerImage3"><img alt="image" src="images/ch4.jpg" width="5%"/></p>
</div>
<p class="para" style="text-indent: 5%;"><a id="pg-4">You crouch over the crack. Your bat sonar tells you that it goes down a long, long way. It might even go on forever. And you’re almost afraid to imagine what you might find inside it.</a></p><a id="pg-4">
<p class="para" style="text-indent: 5%;">Still, you’re a bat.</p>
<p class="para" style="text-indent: 5%;">You’re trapped in the crypt.</p>
<p class="para" style="text-indent: 5%;">What have you got to lose?</p>
<p class="para" style="text-indent: 5%;">You take a deep breath to calm yourself. You do a couple of warm-up flaps of your wings. Then, before you can change your mind, you dive head-first into the crack. But you’re no longer flying!</p>
<p class="para" style="text-indent: 5%;">Instead, you’re falling, falling straight down. What are you doing wrong?</p>
<p class="para" style="text-indent: 5%;">In a panic, you check out your wings. To your amazement, they’re gone! Those are <em class="italic">arms</em> flailing around. <em class="italic">Your</em> arms. You’re a kid again!</p>
<p class="para" style="text-indent: 5%;">You don’t have time to celebrate. You’re falling faster now. And faster. Will you ever land? And will you survive the crash? And if you do, where will you be?</p>
</a><p class="extractLetterText" style="text-indent: 5%;"><a id="pg-4"><em class="italic">Quick! Turn to </em></a><span href="#/e9780545841030_ch135" title="Link target outside of Sample"><em class="italic">PAGE 135</em></span>.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9780545841030_ch004.vue?9d40ff58